import { DISPATCHER } from 'src/features/brands/gorilla/constants/actionType'
import { PartialActionDispatch, ResponseDispatch } from 'src/types'
import {
  edgeColors,
  gorillaAllLabelObjs,
  hamidashiObjs,
  laceColorObjs,
  moutonObjs,
  stitchColorObjs
} from 'src/features/brands/gorilla/constants/color'
import {
  backLaceObjs,
  dominantArmObjs,
  fingerGuardTypeBaseObjs,
  seriesObjs,
  sizeObjs,
  webPartsObjs
} from 'src/features/brands/gorilla/constants/base'
import { objectsFilter } from 'src/features/brands/hooks/dispatchGenerator'

const dispatchBaseStore = {
  series: { objects: seriesObjs, actionType: DISPATCHER['series'] },
  dominantArm: { objects: dominantArmObjs, actionType: DISPATCHER['dominantArm'] },
  fingerGuardType: { objects: fingerGuardTypeBaseObjs, actionType: DISPATCHER['fingerGuardType'] },
  size: { objects: sizeObjs, actionType: DISPATCHER['size'] },
  backLace: { objects: backLaceObjs, actionType: DISPATCHER['backLace'] },
  webParts: { objects: webPartsObjs, actionType: DISPATCHER['webParts'] },
  lace: { objects: laceColorObjs, actionType: DISPATCHER['lace'] },
  edge: { objects: edgeColors, actionType: DISPATCHER['edge'] },
  stitch: { objects: stitchColorObjs, actionType: DISPATCHER['stitch'] },
  hamidashi: { objects: hamidashiObjs, actionType: DISPATCHER['hamidashi'] },
  mouton: { objects: moutonObjs, actionType: DISPATCHER['mouton'] },
  gorillaLabel: { objects: gorillaAllLabelObjs, actionType: DISPATCHER['gorillaLabel'] }
}

export const useDispatcher = (key: string, dispatch: PartialActionDispatch): ResponseDispatch => {
  const item = dispatchBaseStore[key]
  return (selected: string) =>
    dispatch({
      type: item.actionType,
      [key]: objectsFilter(selected, item.objects)
    })
}

// private method
const bomberSeriesDispatcher = (productNumber: string, dispatch: PartialActionDispatch) => {
  const { series } = dispatchBaseStore
  switch (productNumber) {
    case 'SKR':
      return dispatch({
        type: series.actionType,
        series: objectsFilter('bomber', series.objects),
        webParts: { label: 'BOMBER-WEB', value: 'bomberOriginalWeb' },
        fingerGuardType: { label: '指カバー有り(SKR用)', value: 'indexAndMiddleTipOutCover' }
      })
    case 'HUD':
      return dispatch({
        type: series.actionType,
        series: objectsFilter('bomber', series.objects),
        webParts: { label: 'BOMBER-WEB', value: 'bomberOriginalWeb' },
        fingerGuardType: { label: '指カバー有り(HUD用)', value: 'middleTipOutCover' }
      })
    default:
      return dispatch({
        type: series.actionType,
        series: objectsFilter('bomber', series.objects),
        webParts: { label: 'BOMBER-WEB', value: 'bomberOriginalWeb' },
        fingerGuardType: { label: '指カバー有り', value: 'indexCover' }
      })
  }
}

// ごりら印 && シリーズ選択専用
export const useGorillaSeriesDispatcher = (productNumber: string, dispatch: PartialActionDispatch): ResponseDispatch => {
  const { series } = dispatchBaseStore
  return (selected) => {
    switch (selected) {
      case 'bomber':
        return bomberSeriesDispatcher(productNumber, dispatch)
      case 'normal':
        return dispatch({
          type: series.actionType,
          series: objectsFilter('normal', series.objects)
        })
    }
  }
}
